<div class="p-6">
  <h1 class="text-2xl font-bold text-primary mb-2">
    Gestión de paquetes
  </h1>
  <p class="text-gray-600 mb-6">
    Administra y revisa la información de las empresas registradas en la plataforma.
  </p>
  <app-loading *ngIf="isLoading"></app-loading>
  <div *ngIf="!isLoading">
    <app-table-generic [columns]="columns" [data]="companies" [page]="page" [pageSize]="pageSize" [total]="total"
      [actions]="['view']" (view)="goToDetails($event)" (pageChange)="onPageChange($event)">
    </app-table-generic>
  </div>
</div>
